module.exports = __webpack_public_path__ + "static/media/title_statewide.f850be93.svg";